import { BackgroundProps } from './component';

export type BackgroundControlsProps = BackgroundProps;
